<div class="section container">
  <h1 class="text-center">Créer un compte</h1>
  <div class="summary col-xs-12 col-md-8 col-md-offset-2">
    <app-customer-form (customerUpdated)="customerUpdated()" [accountPage]="false"></app-customer-form>
  </div>
</div>
